<template src="./Index.html">
</template>
<script>
export default {
  created() {
    let id = this.$route.params.id;
    this.$store
      .dispatch("doctorPrescriptions/getForPrint", id)
      .then((res) => {
        this.item = res;
      }).catch(() => { });
  },
  data() {
    return {
      item: {},

    };
  },
  computed: {
    user() {
      return this.$store.state.security.user;
    },
  },
  methods: {
    printReceipt() {
      window.print(); // فتح نافذة الطباعة
    },
  },
};
</script>
<style>
.stamp {
  position: absolute;
  bottom: 200px; /* مسافة من الأسفل */
  left: 50%;
  transform: translateX(-50%) rotate(-8deg); /* إضافة ميلان */
  padding: 15px 25px;
  border: 3px solid red;
  border-radius: 8px;
  font-size: 20px;
  font-weight: bold;
  color: red;
  background: white;
  width: 250px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  opacity: 0.9;
}

.stamp .details {
  font-size: 12px;
  font-weight: normal;
  margin-top: 8px;
}


/* //-------------------------------------------- */
.contact-footer {
  position: absolute;
  bottom: 5px;
  /* يضمن الابتعاد عن الحافة السفلية */
  left: 0;
  right: 0;
  font-size: 14px;
  color: #555;
  /* لون النص */
}

.clinic-name {
  font-size: 18px;
  font-weight: bold;
  color: #2c3e50;
  /* لون أزرق غامق */
  margin: 0;
}

.receipt-title {
  font-size: 16px;
  font-weight: bold;
  color: #83c783;
  /* لون أزرق */
}

/* تهيئة التصميم للطباعة بحجم A4 */
.receipt-a4 {
  width: 210mm;
  /* عرض A4 */
  min-height: 290mm;
  /* ارتفاع A4 */
  margin: 0 auto;
  padding: 20px;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

/* إعداد الطباعة */
@media print {
  .receipt-a4 {
    box-shadow: none;
    margin: 0;
  }

  body {
    margin: none;
  }

  .v-btn {
    display: none;
    /* إخفاء زر الطباعة عند الطباعة */
  }
}

.text-h6 {
  color: #83c783;
}

h4,
h5,
span {
  font-family: "Almarai";
}

.text-caption {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
}
</style>
